import React, { useState,useEffect } from "react";
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Assignment';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import useStyles from './Styles';
import {Owner,Item} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import Toast from './Toast';
import Loading from './Loading';
import Title from './Title';
import Yesno from './Yesno';
import { Inc, EventTag, Dataset, Countset, OwnerRoom } from './Inc';
import noImage from './imgs/noimage_profile.png';
import AppBank from './AppBank';
import CopyToClipboard from 'react-copy-to-clipboard';

interface FloorListProps {
	owner:Owner,
	bank:AppBank,
}

const FloorList = (props:FloorListProps)=> {
	Ajax.setEditorId( props.owner.owner_id );
	const classes = useStyles();

	const defEventTags:EventTag[] = [];
	const [states,setStates] = useState({
		buildings: [] as Dataset[],
		buildingKeys: [] as Dataset[],
		floors: [] as Dataset[],
		dep_b: 0,
		dep_f: 0,
		dep_r: 0,
		selectedRoomName: "",
		cats: [] as Countset[],
		myRoom: {} as OwnerRoom,
		rooms: [] as OwnerRoom[],
		isLoading: false,
		isFloorRequestOpen: false,
		toast: "",
	});

	const load = ()=>{
		setStates({...states,"isLoading":true});
		Ajax.send("floor/layout",{},(res:any)=>{
			if( res.ok ){
				//console.log(Tools.toOwnerRooms(res.data.rooms));
				setStates({...states,
					buildings:res.data.buildings,
					buildingKeys:res.data.buildingKeys,
					floors:res.data.floors,
					rooms:Tools.toOwnerRooms(res.data.rooms),
					myRoom:res.data.rooms.find( (room:OwnerRoom) => Number(room.owner_id)===Number(props.owner.owner_id) ) || {},
					cats: Tools.toCatCounts(res.data.cats),
					dep_b:Number(res.data.dep_b),
					dep_f:Number(res.data.dep_f),
					isLoading:false,
					isFloorRequestOpen: false,
					toast:""});
			} else {
				setStates({...states,"isLoading":false});
			}
		});
	}

	const search = (dep_b:number,dep_f:number)=>{
		//setStates((prev)=>({...prev,"isLoading":true}));
		//console.log({dep_b:states.dep_b,dep_f:states.dep_f})
		Ajax.send("floor/list",{dep_b:dep_b,dep_f:dep_f},(res:any)=>{
			if( res.ok ){
				//console.log("rooms",Tools.toOwnerRooms(res.rooms));
				setStates((prev)=>({...prev,rooms:Tools.toOwnerRooms(res.rooms),dep_b:dep_b, dep_f:dep_f, isLoading:false, isFloorRequestOpen: false,toast:""}));
			} else {
				setStates((prev)=>({...prev,"isLoading":false}));
			}
		});
	}

	const copy = ()=>{
		setStates({...states, toast: 'クリップボードにURLをコピーしました'});
	}

	const requestYes = ()=>{
		setStates({...states,"isLoading":true});
		console.log({dep_b:states.dep_b, dep_f:states.dep_f, dep_r:states.dep_r});
		Ajax.send("floor/move",{dep_b:states.dep_b, dep_f:states.dep_f, dep_r:states.dep_r},(res:any)=>{
			if( res.ok ){
				//search(states.dep_b,states.dep_f);
				load();
			} else {
				setStates({...states,"isLoading":false, isFloorRequestOpen:false, toast:"引っ越しに失敗しました。"});
				load();
			}
		});
	}
	const requestNo = ()=>{
		setStates({ ...states, isFloorRequestOpen: false });
	}
	// const update = (event_tag_id:number | undefined, joined_status:string)=>{
	// 	if( event_tag_id===undefined ) return;
	// 	//setStates({...states,"isLoading":true});
	// 	Ajax.send("event/join",{event_tag_id: event_tag_id, status: joined_status},(res:any)=>{
	// 		if( res.ok ){
	// 			console.log("OK");
	// 			const event_tags = states.eventTags.map( (et)=> {
	// 				if( et.event_tag_id === event_tag_id ){
	// 					et.joined_status = joined_status;
	// 				}
	// 				return et;
	// 			});
	// 			setStates({...states,eventTags:event_tags,isLoading:false,toast:""});
	// 		} else {
	// 			setStates({...states,"isLoading":false});
	// 		}
	// 	});
	// }

	// const remove = (event_tag_id:number | undefined)=>{
	// 	if( event_tag_id===undefined ) return;
	// 	//setStates({...states,"isLoading":true});
	// 	Ajax.send("event/remove",{event_tag_id: event_tag_id},(res:any)=>{
	// 		if( res.ok ){
	// 			const event_tags = states.eventTags.filter( (et)=> et.event_tag_id !== event_tag_id );
	// 			setStates({...states,eventTags:event_tags,isLoading:false,toast:""});
	// 		} else {
	// 			setStates({...states,"isLoading":false, toast:"削除できませんでした"});
	// 		}
	// 	});
	// }

	const closeInput = ()=>{
		setStates({ ...states, isFloorRequestOpen: false });
	}
	const closeToast = ()=>{
		setStates({...states,"toast":""});
	}

	const addFloorRequest = async (floorRequest:any) =>{
	// 	setStates({...states,isLoading:true});
	// 	await Ajax.send("event/add",eventTag,(res:any)=>{
	// 		if( res.ok ){
	// 			search();
	// 			//setStates({...states,isLoading:false, isFloorRequestOpen: false});
	// 		} else {
	// 			setStates({...states,isLoading:false, toast:"送信に失敗しました。"});
	// 		}
	// 	});
	}

	const setBuilding = (dep_b:number)=>{
		//setStates((prev)=>{ return { ...prev, dep_b: dep_b }; });
		search(dep_b,states.dep_f);
	}

	const setFloor = (dep_f:number)=>{
		//setStates((prev)=>{ return { ...prev, dep_f: dep_f }; });
		search(states.dep_b,dep_f);
	}

	useEffect( ()=>{
		if( props.owner.owner_id>0 ){
			load();
		}
	},[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		)
	}

    const toPage = "https://store.retro-biz.com/floors/" + states.buildingKeys.find(b=>b.id==String(states.myRoom.dep_b))?.label + "/" + String(states.dep_f);

	return (
		<div id="floor_list" className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={8} lg={9}>
					<Paper className={classes.paper}>
						<Title text="引っ越し"/>
						<div style={{marginBottom:"3em"}}>
							{states.myRoom.dep_b ? (
							<>
							現在、あなたのショップは<span style={{fontWeight:'bold',margin:'0 0.5rem',padding:'0 0.5rem',border:'1px solid teal',color:'teal'}}>{states.buildings.find(b=>b.id==String(states.myRoom.dep_b))?.label} {states.myRoom.room_name}</span>です。<br/>
							ほかの場所に引っ越ししたい場合は、空いている場所を探して「引っ越し」ボタンを押してください。<br/>
							</>
							):(
							<>
							あなたのショップはまだありません。<br/>
							最初の納品が完了すると、空いている場所が一つ割り振られていつでも引っ越しができるようになります。<br/>
							</>
							)}
						</div>
						<div style={{position:'relative',textAlign:'right', marginBottom:"2em",padding:"2em", backgroundColor:"#eeeeee", border:"1px solid #dddddd"}}>
								<Select
									value={states.dep_b}
									className={classes.select}
									sx={{
										position:{md:"relative",lg:"absolute"},
										top:{md:0,lg:"1.2rem"},
										left:{md:0,lg:"1.5rem"},
										textAlign:"left",
										width:{xs:'100%',lg:"10rem",xl:"12rem"},
										height:"2.2rem",
										padding:"0.2em 0.5rem",
										boxSizing:"border-box",
										backgroundColor:"#ffffff"
									}}
									variant="standard"
									onChange={(e) =>
										//setStates({ ...states, dep_b: Number(e.target.value) })
										setBuilding(Number(e.target.value))
									}
								>
								{states.buildings.map((b,index)=>{
									return (
										<MenuItem key={"building"+index} value={b.id}>
											{b.label}
										</MenuItem>
									);
								})}
								</Select>
								<Box sx={{display:'flex',flexWrap:'wrap',gap:'0.4rem',marginTop:{xs:'1rem',lg:'0rem'},marginLeft:{md:0,lg:'11rem',xl:'13rem'}}}>
								{states.floors.map((f,index)=>{
									return (
										<Button
											key={"floor"+index}
											type="button"
											onClick={()=>setFloor(parseInt(f.id))}
											variant={ states.dep_f===parseInt(f.id) ? "contained" : "outlined" }
											sx={{
												margin:0,
												padding:'0',
												width:{xs:'calc(25% - 0.3rem)', sm:'calc(16.6% - 0.32rem)', lg:'calc(9% - 0.34rem)'},
												maxWidth:'auto',
												minWidth:'auto',
												height:'2.2rem',
												boxSizing:"border-box",
												...(states.dep_f !== parseInt(f.id) && { backgroundColor: 'white' }), // 条件付きでbackgroundColorを設定
											}}
											value={f.id}
										>
											{f.label}
										</Button>
									);
								})}
								</Box>
						</div>
						<div style={{borderTop:'1px solid silver'}}>
							{states.rooms.map( (room,index) =>{
								return (
									<div key={"room"+index} style={{position:"relative",borderBottom:'1px solid silver'}}>
										<Box
											sx={{
												position:"absolute",
												top:'0',
												left:'0',
												padding: '0',
												width:{xs:'5rem',sm:'8rem'},
												height:'8rem',
												backgroundColor:'#FFFFFF',
												boxSizing:'border-box',
											}}
										>
											<div style={{position:"absolute",top:"45%",left:"50%",transform:"translate(-50%, -50%)",textAlign:"center",lineHeight:'1rem'}}>
												<Box sx={{fontSize:{xs:'65%',sm:'100%'},marginBottom:'0.5rem'}}>{states.buildings.find(b=>b.id==String(states.dep_b))?.label}</Box>
												<div style={{fontSize:"120%",color:'teal'}}>{room.room_name}</div>
											</div>
										</Box>
										<Box
											sx={{
												position:"absolute",
												top:'0',
												left:{xs:'5rem',sm:'8rem'},
												width:'4rem',
												height:'8rem',
												//backgroundColor:room.owner_id===0 ? '#FFFFFF' : '#f5fff5',
												borderLeft:'1px dashed silver',
												borderRight:'1px dashed silver',
												boxSizing:'border-box',
											}}
										>
											{ room.owner_id===0 ? (
												<div style={{position:'absolute',top:'50%',left:'50%',color:'teal',fontSize:'120%',transform:"translate(-50%,-50%)"}}><SentimentSatisfiedAltIcon/></div>
											):(
												<div style={{position:'absolute',top:'50%',left:'50%',transform:"translate(-50%,-50%)"}}>
											{ room.img_id>0 && room.status==='1' && <StoreImg owner_id={room.owner_id} img_id={room.img_id} thumb={false} className="imgContain"/>}
											{ room.img_id>0 && room.status==='0' && <PsychologyAltIcon/>}
											{ room.img_id===0 && <img src={noImage} style={{width:'100%'}} alt={room.owner_name} className="imgContain" />}
												</div>
											)}
										</Box>
									{ room.owner_id>0 ? (
										<Box sx={{
											marginLeft:{xs:'10rem',sm:'13rem'},
											height:'8rem',
											boxSizing:'border-box',
											position:'relative'
										}}>
											{room.status==='1' ? (
											<div style={{position:"absolute",top:'50%',left:'0rem',transform:"translateY(-50%)"}}>
												<div style={{fontSize:"1rem",color:"#666666"}}>{room.company_name}</div>
												<div style={{fontSize:"1.2rem",marginBottom:"0.5em"}}>{room.owner_name}</div>
											</div>
											):(
											<div style={{position:"absolute",top:'50%',left:'0rem',transform:"translateY(-50%)"}}>
												<div style={{color:'#666666'}}>準備中</div>
											</div>
											)}
										</Box>
									) : (
										<Box sx={{marginLeft:{xs:'10rem',sm:'13rem'},height:'8rem',boxSizing:'border-box',position:'relative'}}>
											<div style={{position:"absolute",top:'50%',left:'0rem',transform:"translateY(-50%)"}}>
												<Box sx={{
													fontSize:"150%",
													marginBottom:{xs:"0.2rem",sm:"0.5em"},
													color:'teal'
												}}>
													空き
												</Box>
												<Box sx={{
													marginTop:'0.5em',
													display:{xs:'block',sm:'none'},
												}}>
													<Button
														size="small"
														variant="contained"
														color="primary"
														onClick={() => setStates((prev)=>{ return { ...prev, dep_r:room.dep_r, selectedRoomName:room.room_name, isFloorRequestOpen: true } })}
														disabled={states.myRoom.dep_b===undefined}
													>
														<FontAwesomeIcon icon={["fas","truck"]} style={{marginRight:"0.5em"}}/>
														引っ越し
													</Button>
												</Box>
											</div>
											<Box sx={{
												position:"absolute",
												top:'50%',
												right:'2rem',
												transform:"translateY(-50%)",
												display:{xs:'none',sm:'block'},
											}}>
												<Button
													variant="contained"
													color="primary"
													onClick={() => setStates((prev)=>{ return { ...prev, dep_r:room.dep_r, selectedRoomName:room.room_name, isFloorRequestOpen: true } })}
													disabled={states.myRoom.dep_b===undefined}
												>
													<FontAwesomeIcon icon={["fas","truck"]} style={{marginRight:"0.5em"}}/>
													引っ越し
												</Button>
											</Box>
										</Box>
									)}
									</div>
								);
							})}
						</div>


					</Paper>
				</Grid>
				<Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="あなたのショップ" size={2}/>
						<div style={{border:'1px solid silver',padding:'2rem',paddingBottom:'2.5rem',textAlign:'center',marginBottom:'1rem'}}>
							{states.myRoom.dep_b ? (
								<>
								<div style={{fontSize:'140%',marginBottom:'0.5rem'}}>{states.buildings.find(b=>b.id==String(states.myRoom.dep_b))?.label}</div>
								<div style={{fontSize:'180%'}}>{states.myRoom.room_name}</div>
								</>
							):(
								<div>まだありません</div>
							)}
						</div>

						<div>
							<div>あなたのフロアのURL</div>
							<div style={{lineHeight:"1.0em",textAlign:"left",marginBottom:'0.5em'}}>
								<input type="text" value={toPage} style={{width:'100%',padding:'0.25em 0.1em',boxSizing:'border-box'}}/>
							</div>
							<div style={{textAlign:"left",marginLeft:'-0.5em'}}>
								<a href={toPage} rel="noopener noreferrer" target="_blank" style={{marginRight:'1rem'}}><Button variant="text" size='small' color="primary" style={{gap:"0.5rem"}}><LaunchIcon/>ページを開く</Button></a>
								<CopyToClipboard text={toPage} onCopy={copy}>
									<Button variant="text" color="primary" size="small" style={{gap:"0.5rem"}}><MessageIcon/>URLをコピー</Button>
								</CopyToClipboard>
							</div>
						</div>
					</Paper>

				</Grid>
			</Grid>
			<Toast mes={states.toast} close={closeToast}/>
			<Yesno mes={"「"+states.buildings.find(b=>b.id==String(states.dep_b))?.label + states.selectedRoomName + "」に引っ越します。\nよろしいですか？"} yes={requestYes} no={requestNo} isOpen={states.isFloorRequestOpen}/>
		</div>
	);
}

export default FloorList;
